/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewings_List_EmptyInputs */

const cs_viewings_list_empty = /** @type {(inputs: Viewings_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné prohlídky. Použijte Naplánovat prohlídku pro přidání.`)
};

const en_viewings_list_empty = /** @type {(inputs: Viewings_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No viewings scheduled yet. Use Schedule viewing to add one.`)
};

/**
* | output |
* | --- |
* | "No viewings scheduled yet. Use Schedule viewing to add one." |
*
* @param {Viewings_List_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const viewings_list_empty = /** @type {((inputs?: Viewings_List_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewings_List_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewings_list_empty(inputs)
	return cs_viewings_list_empty(inputs)
});